import TyumenOurHomeWidget from './component'

export default TyumenOurHomeWidget
